import script from "./AlbumView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumView.vue?vue&type=script&setup=true&lang=js"

import "./AlbumView.vue?vue&type=style&index=0&id=d830f4c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d830f4c0"]])

export default __exports__